export interface PlayerConfig {
  id: string;
  name: string;
  isLocal: boolean;
}

export class Player {
  readonly id: string;
  readonly name: string;
  readonly isLocal: boolean;
  teamIds: string[] = [];
  ready: boolean = false;
  isSpectator: boolean = false;

  constructor(config: PlayerConfig) {
    this.id = config.id;
    this.name = config.name;
    this.isLocal = config.isLocal;
  }

  setSpectator(spectator: boolean): void {
    this.isSpectator = spectator;
    if (spectator) {
      this.teamIds = [];
    }
  }

  assignTeam(teamId: string): void {
    if (!this.teamIds.includes(teamId)) {
      this.teamIds.push(teamId);
    }
  }

  unassignTeam(teamId: string): void {
    this.teamIds = this.teamIds.filter((id) => id !== teamId);
  }

  ownsTeam(teamId: string): boolean {
    return this.teamIds.includes(teamId);
  }

  setReady(ready: boolean): void {
    this.ready = ready;
  }

  serialize(): PlayerConfig & { teamIds: string[]; ready: boolean; isSpectator: boolean } {
    return {
      id: this.id,
      name: this.name,
      isLocal: this.isLocal,
      teamIds: [...this.teamIds],
      ready: this.ready,
      isSpectator: this.isSpectator,
    };
  }

  static deserialize(data: ReturnType<Player['serialize']>): Player {
    const player = new Player({
      id: data.id,
      name: data.name,
      isLocal: data.isLocal,
    });
    player.teamIds = [...data.teamIds];
    player.ready = data.ready;
    player.isSpectator = data.isSpectator ?? false;
    return player;
  }
}

export function generatePlayerId(): string {
  return `player_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
}
